import { render, staticRenderFns } from "./CmgNutritionCalculatorRecentsCard.vue?vue&type=template&id=7ba4db94&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-recents-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-recents-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorRecentsCard.vue?vue&type=style&index=0&id=7ba4db94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba4db94",
  null
  
)

export default component.exports